import React from 'react';
import { getCatalogFilterStoreByProductType } from '../../_flux/stores/catalog_filter_store/factory';
import PostcodeStore from '../../_flux/stores/postcode_store';
import { filtersToStatusbarStatus } from '../../_flux/helper/filters_to_statusbar_status';
import StatusbarConstants from '../../_flux/constants/statusbar_constants';
import { StatusbarMobile } from '../../_flux/components/statusbar/mobile/statusbar_mobile';
import { showMobileFiltersAction } from '../../_flux/actions/catalog_mobile_filter_visibility_actions';
import { openAction as openTyreIndexExplanationAction } from '../../_flux/actions/tyre_index_explanation_lightbox_actions';
import { CatalogMobileFiltersGoogleAnalytics } from '../../_modules/google_analytics/catalog/mobile_filters';
import { onChangeSpecific } from './on_change_specific';
import { handleView } from '../handle_view';
import StatusbarComponent from "../../_flux/components/statusbar/desktop/statusbar";

const stores = {
    postcodeState: PostcodeStore,
};

const render = ({ catalogFilter, postcodeState }, { productType, displayDimensions }) =>
    <StatusbarMobile
        status={filtersToStatusbarStatus(catalogFilter, postcodeState.postcodeExistsButNeedsToBeLoaded)}
        filters={catalogFilter}
        onChangeSpecific={onChangeSpecific}
        onOpenFiltersClick={onOpenFiltersClick}
        onAddMissingClick={onAddMissingClick}
        onLearnMoreClick={openTyreIndexExplanationAction}
        postcodeExistsButNeedsToBeLoaded={postcodeState.postcodeExistsButNeedsToBeLoaded}
        productType={productType}
        displayDimensions={displayDimensions}
    />;

export const init = (container, options) => {
    stores.catalogFilter = getCatalogFilterStoreByProductType(options.productType);
    return handleView(stores, render, options, container);
};

const onOpenFiltersClick = () => {
    CatalogMobileFiltersGoogleAnalytics.openMobileFilters();
    showMobileFiltersAction();
};

const changeAll = onChangeSpecific.bind(null, ['sizes', 'indexes', 'postcode']);
const changeIndexesAndPostcode = onChangeSpecific.bind(null, ['indexes', 'postcode']);
const changePostcode = onChangeSpecific.bind(null, ['postcode']);

const onAddMissingClick = (catalogFilterStore) => () => {
    const status = filtersToStatusbarStatus(catalogFilterStore.getState());

    status === StatusbarConstants.ALL_MISSING ? changeAll()
        : status === StatusbarConstants.DIMENSIONS_MISSING ? changeAll()
            : status === StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING ? changeIndexesAndPostcode
                : status === StatusbarConstants.SPEED_INDEX_MISSING ? changeIndexesAndPostcode
                    : status === StatusbarConstants.LOAD_INDEX_MISSING ? changeIndexesAndPostcode
                        : status === StatusbarConstants.TYRE_INDEX_MISSING ? changeIndexesAndPostcode
                            : status === StatusbarConstants.POSTCODE_MISSING ? changePostcode
                                : undefined;
};
